<template>
    <div class="c-a-input" :class="{ 'c-a-input--invalid': invalid }">
        <label class="c-a-input__label" :for="`input-${id}`">{{ label }}</label>
        <div class="c-a-input__wrapper c-a-input__wrapper--with-icon-right"
            :class="{ 'c-a-input__wrapper--with-icon-left': icon }">
            <icon v-if="icon" class="c-a-input__icon" :icon="icon"></icon>
            <input :type="showPassword ? 'text' : 'password'" class="c-a-input__input" :id="`input-${id}`" :value="value"
                @input="updated" :name="name" :placeholder="placeholder" />
            <button v-if="showPassword" class="c-a-input__icon-button"
                v-tooltip="{ content: 'Dölj lösenord', placement: 'top-center' }" @click="toggleShowPassword()"
                aria-label="Dölj lösenord">
                <icon :icon="'visibility_off'" />
            </button>
            <button v-else class="c-a-input__icon-button" v-tooltip="{ content: 'Visa lösenord', placement: 'top-center' }"
                @click="toggleShowPassword()" aria-label="Visa lösenord">
                <icon :icon="'visibility'" />
            </button>
        </div>
    </div>
</template>

<script>
import Icon from '../AtomIcon.vue';

export default {
    components: {
        Icon
    },
    props: {
        id: Number,
        name: String,
        icon: String,
        label: String,
        placeholder: String,
        value: String,
        invalid: Boolean,
        minLength: Number,
        maxLength: Number
    },
    data() {
        return {
            showPassword: false
        }
    },
    methods: {
        updated(event) {
            this.$emit('input', event.target.value);
        },
        toggleShowPassword() {
            this.showPassword = this.showPassword ? false : true;
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/views/components/atoms/form/AtomInputPassword.vue